if (!customElements.get('ia-compare-chart')) {

class IaCompareChart extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('variant:change', this.handleVariantChange.bind(this));
    this.querySelectorAll('add-to-cart').forEach(addToCart => {
      addToCart.addEventListener('click', (e) => {
        addToCart.querySelector('.js-atc-text')?.classList.add('hidden');
        addToCart.querySelector('.js-atc-text-adding')?.classList.remove('hidden');
      });
    })
    document.addEventListener('cart:allChanges', (e) => {
      this.querySelectorAll('add-to-cart').forEach(addToCart => {
        addToCart.querySelector('.js-atc-text').classList.remove('hidden');
        addToCart.querySelector('.js-atc-text-adding')?.classList.add('hidden');
      });
    });
  }
  getCellWidth() {
    const cellWidthValue = this.querySelector('.compare-chart__cell').clientWidth;
    return parseFloat(cellWidthValue);
  }
  setContainerWidth() {
    const containerWidth = this.clientWidth;
    this.closest('.shopify-section')?.style.setProperty('--table-width', `${containerWidth}px`);
  }
  connectedCallback() {
    this.setContainerWidth();
    window.addEventListener('resize', this.setContainerWidth.bind(this));

    if (window.matchMedia('(pointer: fine)').matches) {
      const chart = this;
      if (!chart) return;

      let isMouseDown = false;
      let startX, scrollLeft;

      chart.addEventListener('mousedown', function(e) {
        
        isMouseDown = true;
        startX = e.pageX - chart.offsetLeft;
        scrollLeft = chart.scrollLeft;
        chart.style.cursor = 'grabbing';
        chart.style.userSelect = 'none';
      });

      chart.addEventListener('mouseleave', function() {
        isMouseDown = false;
        chart.style.cursor = 'default';
        chart.style.userSelect = 'auto';
      });

      chart.addEventListener('mouseup', function() {
        isMouseDown = false;
        chart.style.cursor = 'default';
        chart.style.userSelect = 'auto';
      });

      chart.addEventListener('mousemove', function(e) {
        if (!isMouseDown) return;
        e.preventDefault();
        const x = e.pageX - chart.offsetLeft;
        let direction = 1;
        if (x < startX) {
          direction = -1;
        }
        const walk = direction * this.getCellWidth();
        chart.scrollLeft = scrollLeft - walk;
      });
    }
  }

  handleVariantChange(event) {
    if (event.detail.section !== this.dataset.section) return;
    const variant = event.detail.variant;
    const id = variant.id;
    const price = variant.price;
    document.querySelectorAll('.compare-chart__cell--selected .compare-chart__product-price').forEach(priceElement => {
      if (priceElement.dataset.url === event.detail.url) {
        priceElement.textContent = `${theme.Currency.formatMoney(price, window.shopSettings.moneyFormat)}`;
      }
    })
    document.querySelectorAll('.compare-chart add-to-cart').forEach(addToCart => {
      if (addToCart.dataset.url === event.detail.url) {
        addToCart.dataset.variantId = id;
      }
    })

  }
}
customElements.define('ia-compare-chart', IaCompareChart);
}